import React, {Component} from 'react';
import {StripeProvider} from 'react-stripe-elements';
import {dataRegister} from "../../services/dataRegister";
import {Elements} from 'react-stripe-elements';
import SignupPayment from "../../pages/signup-payment/component";
import queryString from "query-string";
import Styles from './style.css';
import {BeatLoader} from "react-spinners";

class SignupPaymentRedirect extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentDidMount() {}

    render() {
        return (
            <div className={Styles.container}>
                <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
            </div>
        );
    }
}

export default SignupPaymentRedirect;


// WEBPACK FOOTER //
// ./src/pages/signup-payment-redirect/signup-payment-redirect.js